import { Divider, Table, Spin, Select } from 'antd'
import { useEffect, useState, useRef } from 'react'
import { getMazes, getTopUser } from 'src/api/maze'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { fetchCountryProvider } from 'src/api/authen'

const MazeLeaderBoard = () => {
  const mazeHuntersRef = useRef([])
  const [mazeHunterLoading, setmazeHunterLoading] = useState(false)
  const [loading, setLoading] = useState(true)
  const [mazeHunter, setmazeHunter] = useState(undefined)
  const [transformedData, setTransformedData] = useState([])
  const [country, setCountry] = useState('')
  const [countries, setCountries] = useState([])
  const [mazeHunters, setmazeHunters] = useState([])

  const fetchCountry = async () => {
    try {
      const data = await fetchCountryProvider()
      const countryOptions = data.data.map((item) => ({
        label: item.countryName,
        value: item.countryCode,
      }))
      setCountries(countryOptions)

      if (countryOptions.length > 0) {
        setCountry(countryOptions[0].value)
      }
    } catch (error) {
      console.error('Error fetching country data:', error)
    }
  }

  const fetchmazeHunter = async (searchValue = '', shouldSetFirst = true) => {
    try {
      setmazeHunterLoading(true)
      const data = await getMazes(0, 100, searchValue)
      const mazeHunterOptions = data.data.map((item) => ({
        label: item.name,
        value: item.id,
      }))
      mazeHuntersRef.current = mazeHunterOptions
      setmazeHunters(mazeHunterOptions)

      if (shouldSetFirst && mazeHunterOptions.length > 0) {
        setmazeHunter(mazeHunterOptions[0].value)
      }
    } catch (error) {
      console.error('Error fetching maze hunters:', error)
    } finally {
      setmazeHunterLoading(false)
    }
  }

  const handleCountryChange = (value) => {
    setCountry(value)
  }

  const fetchTopScoresData = async (id, country) => {
    try {
      setLoading(true)
      const response = await getTopUser(id, country)
      const transformedData = response.data
      setTransformedData(transformedData)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCountry()
    fetchmazeHunter('', true)
  }, [])

  useEffect(() => {
    if (mazeHunter && country) {
      fetchTopScoresData(mazeHunter, country)
    }
  }, [country, mazeHunter])

  const columns = [
    {
      title: 'Rank',
      dataIndex: 'rank',
      key: 'rank',
    },
    {
      title: 'User Name',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Seconds',
      dataIndex: 'seconds',
      key: 'seconds',
    },
  ]

  return (
    <>
      <Spin spinning={loading}>
        <Select
          showSearch
          placeholder="Select Maze Hunter"
          value={mazeHunter || undefined}
          onChange={(value) => setmazeHunter(value)}
          onSearch={(value) => {
            const filtered = mazeHuntersRef.current.filter((hunter) =>
              hunter.label.toLowerCase().includes(value.toLowerCase())
            )
            setmazeHunters(filtered)
          }}
          onClear={() => {
            setmazeHunter(undefined)
            setmazeHunters(mazeHuntersRef.current)
          }}
          filterOption={false}
          allowClear
          options={mazeHunters}
          style={{ width: '15%', marginLeft: '10px' }}
          loading={mazeHunterLoading}
        />

        <Select
          placeholder="Select Country"
          value={country}
          onChange={handleCountryChange}
          options={countries}
          style={{ width: '15%', marginLeft: '10px' }}
        />
        <Divider />
        <DndProvider backend={HTML5Backend}>
          <Table
            dataSource={transformedData}
            columns={columns}
            pagination={false}
          />
        </DndProvider>
      </Spin>
    </>
  )
}

export default MazeLeaderBoard
